module.exports = __webpack_public_path__ + "img/image11.bdea76d8.webp";